import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './project.module.scss';
import location from '../../../static/images_pfizer/assistant/location.png';
import arrow_down from '../../../static/images_pfizer/assistant/arrow_down.png';
import assistant_doctor_avatar from '../../../static/images_pfizer/assistant/assistant_doctor_avatar.png';
import project_card from '../../../static/images_pfizer/assistant/project_card.png';
import project_icon from '../../../static/images_pfizer/assistant/project_icon.png';
import invite_doctor from '../../../static/images_pfizer/assistant/invite_doctor.png';
import  { ApiCore } from '../../api/index';
import { withRouter } from 'react-router-dom';

const api = new ApiCore();

function Project(props: any) {
    
    const [list, setList] = useState([]);
    const [groupList, setGroupList] = useState([]);

    useEffect(() => {
        initData();
        getTeamDoctors();
        return () => {
        }
    }, [])

    const initData = () => {
        api.getGroupSelfList().then((res: any) => {
            if (res.code == 0) {
                setGroupList(res.data || []);
            }
        });
    }

    const getTeamDoctors = () => {
        let info = sessionStorage.getItem('RegisterGetInfo');
        if (info) {
            let _info = JSON.parse(info);
            const param = {
                groupCode: _info.groupCode
            }
            api.getTeamDoctors(param).then((res: any) => {
                if (res.code == 0) {
                    setList(res.data || []);
                }
            })
        }
    }

    const toDetail = (val: any) => {
        props.history.push(`/pfizer/assistant/projectDetail?groupCode=${val.groupCode}&groupName=${val.groupName}`);
    }

    return (
        <div className={`${styles.project_content}`}>
            {
                groupList && groupList.map((val: any, key: number) => (
                    <div key={key} className={`${styles.project_list_item}`} onClick={() => {  toDetail(val) }}>
                        <div className={styles.title_wrap}>
                            <div className={styles.border}></div>
                            <div className={styles.title}>{val.groupName}</div>
                            {/* <div className={styles.status_ing}>进行中</div> */}
                        </div>
                        <div className={styles.np_op}>
                            <span className={styles.np_op_title}>NP / OP</span>
                            <span className={styles.np_op_number}>{val.npNum} / {val.opNum}</span>
                        </div>
                    </div>
                ))
            }
        </div>
    )

}

export default withRouter(Project);